module.exports = __webpack_public_path__ + "img/bubble_layout_4.03ff9b7f.svg";